const projects = [
  {
    title: "Word Of The Day",
    description: "A full-stack app that serves a daily Japanese vocabulary word with reading, meaning, and usage. The application refreshes once a day for every visitor.",
    technologies: ["C#", "Azure Table Storage", "Azure Functions", "React"],
    isPath: false,
    path: "https://github.com/EricChen-01/WordOfTheDay",
    links: [
      {
        label: "Project Site",
        href: "https://wordoftheday.ericgchen.com",
        external: true,
      }
    ],
    image: "https://wordoftheday.ericgchen.com/favicon.svg",
  },
  {
    title: "Redstone",
    description:
      "Redstone is a custom scripting language written in C# that reimagines common programming constructs using Minecraft-themed keywords while remaining fully executable. The project includes a complete language pipeline, lexical analysis to runtime evaluation, alongside a custom VS Code extension for syntax highlighting and developer ergonomics.",
    technologies: ["C#"],
    isPath: false,
    path: "https://github.com/EricChen-01/Redstone",
    image:
      "",
  },
  {
    title: "QRGen",
    description:
      "A small React + TypeScript web application to create and style QR codes.",
    technologies: ["React", "TypeScript", "Vite"],
    isPath: false,
    path: "https://github.com/EricChen-01/QRGen",
    links: [
      {
        label: "Project Site",
        href: "https://qrgen.ericgchen.com",
        external: true,
      },
    ],
    image: "/images/qrgen.png",
  },
  {
    title: "GitHub Summarizer Semantic Kernel AI Plugin",
    description:
      "A Semantic Kernel AI plugin that I've developed during my time as a Microsoft intern that summarizes GitHub repositories AI.",
    technologies: ["C#", "Semantic Kernel"],
    isPath: false,
    path: "https://github.com/EricChen-01/GitHubQAChatGPTPlugin",
    image:
      "https://devblogs.microsoft.com/semantic-kernel/wp-content/uploads/sites/78/2024/03/Large_SK_Logo.png",
  },
  {
    title: "AR Mini Golf Simulator",
    description:
      "A mini golf simulator built using Unity and C# that leverages Augmented Reality (AR) technology to create an immersive golfing experience in real-world environments. Players can set up virtual mini golf courses in their surroundings, interact with realistic physics-based gameplay, and enjoy a fun and engaging AR golfing adventure.",
    technologies: ["C#", "Unity", "AR"],
    isPath: false,
    path: "https://github.com/EricChen-01/MiniGolfVR",
    image:
      "https://raw.githubusercontent.com/EricChen-01/MiniGolfVR/refs/heads/main/MiniGolf.png",
  },
  {
    title: "JEMS",
    description:
      "JEMS is a map-design social platform where users create and share custom maps. Users can import their own geometric map files or start from predefined maps, add overlays and custom data, and export their designs as shareable images.",
    technologies: ["Typescript", "MongoDB", "ExpressJs", "Leaflet"],
    isPath: false,
    path: "https://github.com/JEMS-CSE416/JEMS",
    image: "/images/Jems.png",
    links: [
      {
        label: "Project Document",
        href: "https://docs.google.com/document/d/1tM8xPhdPV0YCqEauyfCkZ7H9PylHb4w-IZ7BErHc9L0/edit?tab=t.0#heading=h.gp1ng7x3chni",
        external: true,
      },
    ],
  },
  {
    title: "Hopper Hacks 2024",
    description:
      "Stony Brook University's Women In Computer Science Hopper Hacks 2024",
    technologies: ["HTML", "CSS"],
    isPath: false,
    path: "https://www3.cs.stonybrook.edu/~wics/hopperhacks/2024/",
    image:
      "https://www3.cs.stonybrook.edu/~wics/hopperhacks/2024/static/media/Hopper%20Sleeping%20Main.d31346e151613d3a1266.png",
  },
  {
    title: "PlayLister",
    description:
      "A website where users can create playlists thats can be edited and shared amongst one another. Playlists can be viewed, edited, published, and duplicated by playlist owner.",
    technologies: ["MongoDB", "ExpressJS", "ReactJS", "NodeJS"],
    isPath: false,
    path: "https://github.com/EricChen-01/PlayLister",
    image: "",
  },
];

export default projects 